import { CallbackIntervalStore } from 'stores/common/CallbackInterval';
import { AnyObject } from 'utils/types';

import ApiRequest from '../ApiRequest';
import { ApiCallArgs } from '../types';

type PollApiRequestStoreParams<Response = any> = {
  interval: number;
  callback: (data: Response) => void;
} & ApiCallArgs;

/** Стор-утилита для поллинга запросов */
class PollApiRequest<
  Request extends AnyObject | FormData = AnyObject,
  Response = any
> {
  constructor(params: PollApiRequestStoreParams) {
    this._pollParams = params;

    this._apiRequest = new ApiRequest(params);
  }

  private readonly _pollParams: PollApiRequestStoreParams<Response>;

  private _scheduler: CallbackIntervalStore;

  private readonly _apiRequest: ApiRequest;

  async poll(params?: Omit<ApiCallArgs<Request>, 'endpoint'>): Promise<void> {
    const response = await this._apiRequest.call<Response, Request>(params);

    if (!response.data) {
      return;
    }

    this._pollParams.callback(response.data);
  }

  stop(): void {
    this._scheduler.stop();
    this._apiRequest.cancel();
  }

  async start(params?: Omit<ApiCallArgs<Request>, 'endpoint'>): Promise<void> {
    if (this._scheduler) {
      this._scheduler.destroy();
    }

    this._scheduler = new CallbackIntervalStore({
      timeout: this._pollParams.interval,
      callBack: () => this.poll(params),
    });

    await this._scheduler.start();
  }

  destroy() {
    this._scheduler?.destroy();
    this._apiRequest.destroy();
  }
}

export default PollApiRequest;
